import { CurrentUserI } from "@/interfaces/User";

export function CheckReferralPoints(
  ph: CurrentUserI["pointHistory"] | undefined
) {
  if (ph) {
    let count = 0;
    ph.map((p) => {
      if (!(p.reason && p.reason.includes("Referral"))) {
        count += p.points;
      }
    });
    return 500 - count;
  } else {
    return 500;
  }
}
